// extracted by mini-css-extract-plugin
module.exports = {"categoryCard":"Categorie_categoryCard__1ZMtc","categoryImage":"Categorie_categoryImage__2hOst","categoryTitle":"Categorie_categoryTitle__QK1Kt"};